export default {
  // Upload image
  UPLOAD_IMAGE_REQUEST(state) {
    state.imageUpload.loading = true
    state.imageUpload.error = ''
    state.imageUpload.progress = 0
    state.imageUpload.result = null
  },
  UPLOAD_IMAGE_SUCCESS(state, data) {
    state.imageUpload.loading = false
    state.imageUpload.error = ''
    state.imageUpload.progress = 100
    state.imageUpload.result = data
  },
  UPLOAD_IMAGE_FAILURE(state, error) {
    state.imageUpload.loading = false
    state.imageUpload.error = error
    state.imageUpload.progress = 0
    state.imageUpload.result = null
  },

  // Upload video source
  UPLOAD_VIDEO_SOURCE_REQUEST(state) {
    state.videoSourceUpload.loading = true
    state.videoSourceUpload = {
      loading: true,
      error: '',
      progress: 0,
      result: null,
    }
  },
  UPLOAD_VIDEO_SOURCE_SUCCESS(state, data) {
    state.videoSourceUpload = {
      loading: false,
      error: '',
      progress: 100,
      result: data,
    }
  },
  UPLOAD_VIDEO_SOURCE_FAILURE(state, error) {
    state.videoSourceUpload = {
      loading: false,
      error,
      progress: 0,
      result: null,
    }
  },

  // Set uploaded image
  SET_UPLOADED_IMAGE(state, imageData) {
    state.uploadedImage = { ...state.uploadedImage, ...imageData }
  },

  // Clear uploaded image
  CLEAR_UPLOADED_IMAGE(state) {
    state.uploadedImage = {
      file: null,
      url: '',
      name: '',
      loading: false,
      error: '',
    }
  },

  // Generate image prompt
  GENERATE_IMAGE_PROMPT_REQUEST(state) {
    state.imagePrompt.loading = true
    state.imagePrompt.error = ''
    state.imagePrompt.result = null
  },
  GENERATE_IMAGE_PROMPT_SUCCESS(state, data) {
    state.imagePrompt.loading = false
    state.imagePrompt.error = ''
    state.imagePrompt.result = data
    // The prompt text is directly in data, not nested
    state.imagePrompt.prompt = data || ''
  },
  GENERATE_IMAGE_PROMPT_FAILURE(state, error) {
    state.imagePrompt.loading = false
    state.imagePrompt.error = error
    state.imagePrompt.result = null
    state.imagePrompt.prompt = ''
  },

  // Generate video
  GENERATE_VIDEO_REQUEST(state) {
    state.videoGeneration.loading = true
    state.videoGeneration.error = ''
    state.videoGeneration.result = null
    state.videoGeneration.taskId = null
  },
  GENERATE_VIDEO_SUCCESS(state, data) {
    state.videoGeneration.loading = false
    state.videoGeneration.error = ''
    state.videoGeneration.result = data
    state.videoGeneration.taskId = data?.taskId || data?.id || null
  },
  GENERATE_VIDEO_FAILURE(state, error) {
    state.videoGeneration.loading = false
    state.videoGeneration.error = error
    state.videoGeneration.result = null
    state.videoGeneration.taskId = null
  },

  // Poll video status
  POLL_VIDEO_STATUS_REQUEST(state) {
    state.videoPolling.loading = true
    state.videoPolling.error = ''
  },
  POLL_VIDEO_STATUS_SUCCESS(state, data) {
    state.videoPolling.loading = false
    state.videoPolling.error = ''
    state.videoPolling.result = data
    // Extract status and video URL from the response
    if (data && data.length > 0) {
      const taskData = data[0]
      state.videoPolling.status = taskData.status
      state.videoPolling.videoUrl = taskData.videoUrl || taskData.url
    }
  },
  POLL_VIDEO_STATUS_FAILURE(state, error) {
    state.videoPolling.loading = false
    state.videoPolling.error = error
  },

  // Polling control
  SET_POLLING_INTERVAL(state, interval) {
    state.videoPolling.pollingInterval = interval
  },
  STOP_VIDEO_POLLING(state) {
    if (state.videoPolling.pollingInterval) {
      clearInterval(state.videoPolling.pollingInterval)
      state.videoPolling.pollingInterval = null
    }
  },

  // Selected videos
  SET_SELECTED_VIDEOS(state, videos) {
    state.selectedVideos = videos
  },
  ADD_SELECTED_VIDEO(state, video) {
    const existingIndex = state.selectedVideos.findIndex(v => v.id === video.id)
    if (existingIndex >= 0) {
      state.selectedVideos.splice(existingIndex, 1, video)
    } else {
      state.selectedVideos.push(video)
    }
  },
  REMOVE_SELECTED_VIDEO(state, videoId) {
    state.selectedVideos = state.selectedVideos.filter(v => v.id !== videoId)
  },
  CLEAR_SELECTED_VIDEOS(state) {
    state.selectedVideos = []
  },

  // Generate form video
  GENERATE_FORM_VIDEO_REQUEST(state) {
    state.formVideoGeneration.loading = true
    state.formVideoGeneration.error = ''
    state.formVideoGeneration.result = null
  },
  GENERATE_FORM_VIDEO_SUCCESS(state, data) {
    state.formVideoGeneration.loading = false
    state.formVideoGeneration.error = ''
    state.formVideoGeneration.result = data
  },
  GENERATE_FORM_VIDEO_FAILURE(state, error) {
    state.formVideoGeneration.loading = false
    state.formVideoGeneration.error = error
    state.formVideoGeneration.result = null
  },

  // Video list mutations
  FETCH_VIDEO_LIST_REQUEST(state) {
    state.videoList.loading = true
    state.videoList.error = null
  },
  FETCH_VIDEO_LIST_SUCCESS(state, { data, pagination }) {
    state.videoList.loading = false
    state.videoList.error = null
    state.videoList.videos = data
    state.videoList.pagination = { ...state.videoList.pagination, ...pagination }
  },
  FETCH_VIDEO_LIST_FAILURE(state, error) {
    state.videoList.loading = false
    state.videoList.error = error
  },
  ADD_VIDEO_TO_LIST(state, video) {
    state.videoList.videos.unshift(video)
  },
  UPDATE_VIDEO_IN_LIST(state, { id, updates }) {
    const index = state.videoList.videos.findIndex(video => video.id === id)
    if (index !== -1) {
      state.videoList.videos.splice(index, 1, { ...state.videoList.videos[index], ...updates })
    }
  },
  REMOVE_VIDEO_FROM_LIST(state, id) {
    state.videoList.videos = state.videoList.videos.filter(video => video.id !== id)
  },
  CLEAR_VIDEO_LIST(state) {
    state.videoList.videos = []
    state.videoList.pagination = {
      page: 1,
      limit: 15,
      total: 0,
      totalPages: 0,
    }
  },

  // Clear errors
  CLEAR_ERRORS(state) {
    state.error = null
    state.message = ''
    state.imageUpload.error = ''
    state.uploadedImage.error = ''
    state.imagePrompt.error = ''
    state.videoGeneration.error = ''
    state.videoPolling.error = ''
    state.videoList.error = null
    state.imageGeneration.error = null
    state.imageGenerationPolling.error = null
  },

  // AI Analyze mutations
  SET_AI_ANALYZE_LOADING(state, loading) {
    state.aiAnalyze.loading = loading
  },
  SET_AI_ANALYZE_RESULT(state, result) {
    state.aiAnalyze.result = result
    state.aiAnalyze.error = ''
  },
  SET_AI_ANALYZE_ERROR(state, error) {
    state.aiAnalyze.error = error
    state.aiAnalyze.result = null
  },
  CLEAR_AI_ANALYZE_ERROR(state) {
    state.aiAnalyze.error = ''
  },

  // Prompt suggestions mutations
  FETCH_PROMPT_SUGGESTIONS_REQUEST(state) {
    state.promptSuggestions.loading = true
    state.promptSuggestions.error = null
  },
  FETCH_PROMPT_SUGGESTIONS_SUCCESS(state, data) {
    state.promptSuggestions.loading = false
    state.promptSuggestions.error = null
    state.promptSuggestions.data = data
  },
  FETCH_PROMPT_SUGGESTIONS_FAILURE(state, error) {
    state.promptSuggestions.loading = false
    state.promptSuggestions.error = error
  },

  // Image generation mutations
  GENERATE_IMAGE_REQUEST(state) {
    state.imageGeneration.loading = true
    state.imageGeneration.error = null
    state.imageGeneration.result = null
    state.imageGeneration.taskId = null
    state.imageGeneration.status = null
    state.imageGeneration.generatedImageUrl = null
  },
  GENERATE_IMAGE_SUCCESS(state, data) {
    state.imageGeneration.loading = false
    state.imageGeneration.error = null
    state.imageGeneration.result = data
    state.imageGeneration.taskId = data?.result?._id || data?._id // eslint-disable-line no-underscore-dangle
    state.imageGeneration.status = data?.result?.status || data?.status
  },
  GENERATE_IMAGE_FAILURE(state, error) {
    state.imageGeneration.loading = false
    state.imageGeneration.error = error
  },

  // Image generation polling mutations
  POLL_IMAGE_GENERATION_REQUEST(state) {
    state.imageGenerationPolling.loading = true
    state.imageGenerationPolling.error = null
  },
  POLL_IMAGE_GENERATION_SUCCESS(state, data) {
    state.imageGenerationPolling.loading = false
    state.imageGenerationPolling.error = null
    state.imageGenerationPolling.result = data
    state.imageGenerationPolling.status = data?.result?.content?.[0]?.status || data?.status
  },
  POLL_IMAGE_GENERATION_FAILURE(state, error) {
    state.imageGenerationPolling.loading = false
    state.imageGenerationPolling.error = error
  },
  SET_IMAGE_GENERATION_POLLING_INTERVAL(state, interval) {
    state.imageGenerationPolling.pollingInterval = interval
  },
  CLEAR_IMAGE_GENERATION_POLLING_INTERVAL(state) {
    if (state.imageGenerationPolling.pollingInterval) {
      clearInterval(state.imageGenerationPolling.pollingInterval)
      state.imageGenerationPolling.pollingInterval = null
    }
    state.imageGenerationPolling.loading = false
  },
  SET_GENERATED_IMAGE_URL(state, payload) {
    state.imageGeneration.generatedImageUrl = payload.url
    state.imageGeneration.generatedImagePromptText = payload.promptText || null
  },
  // Overall image generation process mutations
  START_IMAGE_GENERATION_PROCESS(state) {
    state.imageGenerationProcess.loading = true
  },
  END_IMAGE_GENERATION_PROCESS(state) {
    state.imageGenerationProcess.loading = false
  },
}
